/* eslint-disable  */
import { Avatar } from "@material-ui/core";
import React, { useEffect } from "react";
import  { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { format } from 'timeago.js';
import { notificationsActionCreators, userDataActionCreators } from "../../../../../service/action-creators";
import NotFoundComponent from "../../../../NotFoundComponent";
function SectionTwo() {
  const dispatch = useDispatch();
  const history = useHistory()
  const { GetNotifications } = bindActionCreators(
    notificationsActionCreators,
    dispatch
  );
  const { GetAppliedLoans, GetMyOrders } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );

  const notifications = useSelector(
    (state) => state?.notification?.notifications
  );
  const user = useSelector(
    (state) => state?.user
  );
  const {myAppliedLoans, orders} = user
 
  console.log("notifications", notifications);

  useEffect(() => {
    GetNotifications();
    GetAppliedLoans();
    GetMyOrders();

  }, []);
  // Build a unified recent activity feed
  const loanColorMap = { submitted: "#888", initiated: "#dd7600", rejected: "#e53935", paid: "#01a94b", booked: "#0067dd", authorized: "#7b1fa2" };
  const orderColorMap = { submitted: "#888", initiated: "#dd7600", rejected: "#e53935", approved: "#01a94b", shipping: "#0067dd" };

  const activityItems = [
    ...notifications.slice(0, 3).map((n) => ({
      type: "notification",
      title: n?.title || "Notification",
      msg: n?.message?.length > 70 ? n.message.slice(0, 70) + "..." : n?.message,
      time: n?.created_at,
      dotColor: "#01a94b",
      pill: null,
      action: () => history.push("/notifications"),
    })),
    ...myAppliedLoans.map((loan) => ({
      type: "loan",
      title: "Loan Application",
      msg: "Your loan application status has been updated",
      time: loan?.created_at,
      dotColor: loanColorMap[loan?.status] || "#888",
      pill: { label: loan?.status, color: loanColorMap[loan?.status] || "#888" },
      action: () => history.push("/my-applied-loans"),
    })),
    ...orders.map((order) => ({
      type: "order",
      title: "Order Application",
      msg: "Your order status has been updated",
      time: order?.created_at,
      dotColor: orderColorMap[order?.status] || "#888",
      pill: { label: order?.status, color: orderColorMap[order?.status] || "#888" },
      action: () => history.push("/my-orders-and-purchase"),
    })),
  ].sort((a, b) => new Date(b.time) - new Date(a.time));

  return (
    <div className="SectionTwoNotificationSection">
      <div className="NotificationPanel">

        <div className="homePanel-section">
          <div className="homePanel-header">
            <span className="homePanel-title">Recent Activity</span>
            {activityItems.length > 0 && (
              <span className="homePanel-badge">{activityItems.length}</span>
            )}
          </div>

          {activityItems.length > 0 ? (
            <div className="homePanel-list">
              {activityItems.map((item, index) => (
                <div className="homePanel-item" key={index} onClick={item.action} style={{ cursor: "pointer" }}>
                  <div className="homePanel-dot" style={{ background: item.dotColor }} />
                  <div className="homePanel-itemBody" style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 6 }}>
                      <p className="homePanel-itemTitle">{item.title}</p>
                      {item.pill && (
                        <span className="homePanel-statusPill" style={{ background: item.pill.color }}>
                          {item.pill.label}
                        </span>
                      )}
                    </div>
                    <p className="homePanel-itemMsg">{item.msg}</p>
                    <span className="homePanel-time">{format(item.time)}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="homePanel-empty">No recent activity</p>
          )}
        </div>

      </div>
    </div>
  );
}

export default SectionTwo;
